'use strict';

angular.module('shiftTraderApp')
  .service('MediaStore', ['Media', '$q', '$rootScope', '$timeout', 'saMediaExpirationSeconds', function(Media, $q, $rootScope, $timeout, saMediaExpirationSeconds) {

    var records = {};

    var batches = [];
    var dataRequests = [];

    var that = this;

    // Creates a new batch to be requested.
    // mediaIds contains all of the ids to be
    // requested when being processed.
    function createBatch(request) {
      var newBatch = {
        open: true,
        mediaIds: request.mediaIds,
        requests: [request],
        timeout: $timeout(function() {
          processBatch(newBatch);
        }, 50),
        globalTimeout: $timeout(function() {
          $timeout.cancel(newBatch.timeout);
          processBatch(newBatch);
        }, 250)
      };
      batches.push(newBatch);

      return newBatch;
    }

    function createDataRequest(ids, callback) {
      var request = {
        mediaIds: ids,
        callback: callback
      };
      dataRequests.push(request);

      return request;
    }

    function createOrAddRequestToBatch(request) {
      var matchingBatch = _.find(batches, function(batch) {
        return batch.open && batch.mediaIds.length < (50 - request.mediaIds.length);
      });

      if (matchingBatch) {
        $timeout.cancel(matchingBatch.timeout);
        matchingBatch.mediaIds = _.union(matchingBatch.mediaIds, request.mediaIds);

        matchingBatch.requests.push(request);
        matchingBatch.timeout = $timeout(function() {
          processBatch(matchingBatch);
        }, 50);
      } else {
        createBatch(request);
      }
    }

    function processBatch(batch) {
      batch.open = false;

      var data = {
        ids: batch.mediaIds.join(',')
      };

      if (batch.globalTimeout) {
        $timeout.cancel(batch.globalTimeout);
      }

      Media.getAll(data)
        .then(function(media) {
          _cacheMediaObjects(media);
          _.each(batch.requests, function(request) {
            request.callback(request.mediaIds);
          });
        }, function(response) {
          _.each(batch.requests, function(request) {
            request.callback(undefined);
          });
        });
    }

    function getMediaByIds(ids) {
      var deferred = $q.defer();

      if (!Array.isArray(ids)) {
        deferred.reject([]);
        return deferred.promise;
      }

      var uncachedIds = _.filter(ids, function(e){
        return !records[e] || _isMediaStale(records[e]);
      });

      if (uncachedIds.length) {
        var callback = function(mediaIds) {
          if (mediaIds) {
            var res = _grabMediaFromCache(mediaIds);
            deferred.resolve(_grabMediaFromCache(mediaIds));
          } else {
            deferred.reject();
          }
        };

        createOrAddRequestToBatch(createDataRequest(uncachedIds, callback));
      } else {
        deferred.resolve(_grabMediaFromCache(ids));
      }

      return deferred.promise;
    }

    this.flush = function() {
      records = {};
      batches = [];
      dataRequests = [];
    };

    $rootScope.$on('flushCaches', function() {
      that.flush();
    });

    // Private

    function _grabMediaFromCache(ids) {
      var out = _.map(ids, function(e) { return records[e]; });
      return _.filter(out, function(e) { return !!e; });
    }

    function _cacheMediaObjects(objects) {
      var now = (new Date).getTime();
      _.each(objects, function(e) {
        e._fetched_at = now;
        records[e.id] = e;
      });
    }

    function _isMediaStale(object) {
      var fetched = object._fetched_at;
      if (fetched) {
        return (((new Date).getTime() - fetched)/1000) > saMediaExpirationSeconds;
      } else {
        return true;
      }
    }

    return {
      getMediaByIds: getMediaByIds,
      flushCache: that.flush
    };

  }]);
